import { Injectable } from '@angular/core';
import { Customer } from './../customers/customers';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component'

@Injectable({
  providedIn: 'root'
})

export class CustomerService {

  private baseURL = environment.baseUrl;
  private subject = new BehaviorSubject<Customer[]>([]);

  gridObject$: Observable<Customer[]> = this.subject.asObservable();
  isLoading = true;

  constructor(private http: HttpClient, private messager: MessagerComponent) {}

  init() {
    const http$ = this.gridHttp();

    http$.pipe(
     tap(() => {
       this.isLoading = false;
     })
    ).subscribe(
      res => this.subject.next(res.Customers)
    );
  }

  getOneCustomer(id): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/customers/edit/' + id).pipe(tap(
      (event)=> {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close', 'errorAlert');
        } else {
        }
      }
    ));
  }


  getOneCustomerLocId(location_id: any): Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/customers/getOneLocId/' + location_id).pipe(tap(
      (event)=> {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close', 'errorAlert');
        } else {
        }
      }
    ));
  }

  sendCustomerEmail(customer_name: string, who: string, text: string): Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/sendCustomerEmail', {customer_name: customer_name, who: who, text:text},{observe: 'body'});
  }


  addCustomer(changes): Observable<any> {

    const customers = this.subject.getValue();


    return this.http.post(this.baseURL + '/rhAPI/customers/create', changes).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close', 'errorAlert');
          this.subject.next(customers);
        } else {
          this.messager.openSnackBar(message, '', 'successAlert');
        }
      })
    );


  }

  getBaseURL = ()=> this.baseURL;


  addOneFrontend(changes): void {

    const customers = this.subject.getValue();

    const newCustomerList = customers.slice(0);
    newCustomerList.unshift(changes);

    this.subject.next(newCustomerList);

  }

  saveEdit(id: number, changes): Observable<any> {

    const customers = this.subject.getValue();

    const custIndex = customers.findIndex(customer => customer.customer_id === id);
    const newcustList = customers.slice(0);


    newcustList[custIndex] = {
      ...customers[custIndex],
      ...changes
    };

    this.subject.next(newcustList);
    return this.http.post(this.baseURL + '/rhAPI/customers/edit/' + id,changes).pipe(
      tap((event) => {
        const message = event.Message as unknown as string;
        if (event.Error) {
          this.messager.openSnackBar(message, 'Close','errorAlert');
          this.subject.next(customers);
        } else {
          this.messager.openSnackBar(message, '', 'successAlert');
        }
      })
    )

  }

  getInitial() {
    return this.gridObject$.pipe(
      map(objects => objects)
    );
  }

  gridHttp(): Observable<any> {
    return this.http.get<Customer[]>(this.baseURL + '/rhAPI/customers', {observe: 'body'});
  }

  // Card 6TSzF61V: the backend soft-deletes, so flip the row in place instead of
  // splicing it out — the grid re-renders it as Inactive rather than losing it.
  deleteCustomer(customerId: number) {

    const customers = this.subject.getValue();
    const customerIndex = customers.findIndex(customer => customer.customer_id === customerId);

    if (customerIndex === -1) { return; }

    const newCustomerList = customers.slice(0);

    newCustomerList[customerIndex] = {
      ...customers[customerIndex],
      inactivecustomer: true
    };
    this.subject.next(newCustomerList);

  }

}
